import {h, Component} from "preact";
import {route} from "preact-router";
import Ticket from "../utils/ticket-logic.jsx";

import * as P from "../mobile-templates/tournament.jsx";

import AwrabetPrematchEventPreview from "../../awrabet/mobile-components/prematch-event-preview.jsx";

export default class PrematchEventPreview extends AwrabetPrematchEventPreview {
	render({tournament, event, tournamentCard}) {
		return <P.EventCard>
			<P.EventInfoRow onClick={() => route("/prematch/"+tournament.id.split('/').slice(2).join('/')+'/'+event.id.split('/').slice(2).join('/'))}>
				<P.EventTeams>
					<P.TeamHolder>
						<P.TeamSymbol side="home" url={""} />
						<P.TeamName>{event.home}</P.TeamName>
					</P.TeamHolder>
					<P.TeamHolder>
						<P.TeamName>{event.away}</P.TeamName>
						<P.TeamSymbol side="away" url={""} />
					</P.TeamHolder>
				</P.EventTeams>
				<P.EventFullDate>{this.getLocalEventDate(event)}</P.EventFullDate>
			</P.EventInfoRow>
			<P.MatchMarkets>
				{this.getMarkets(event, tournamentCard).map(market => <P.MarketContainer>
					<P.MarketTitle>{market.name}</P.MarketTitle>
					<P.OddButtonsGrid cols={Object.keys(market.sub).length}>
						{Object.values(market.sub).map(odd => 
						<P.OddButtonFull
								value={odd.value} 
								onClick={() => Ticket.togglePrematchOdds(odd.id)} 
								selected={Ticket.hasPrematchOdds(odd.id)}>
							<P.OddName>{odd.name}</P.OddName>
							<P.OddValue 
								selected={Ticket.hasPrematchOdds(odd.id)} 
								value={odd.value} />
						</P.OddButtonFull>)}
					</P.OddButtonsGrid>
				</P.MarketContainer>)}
				<div class="h-2" />
			</P.MatchMarkets>
		</P.EventCard>
	}
}